import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

interface UpdateManualOrderMetadataParams {
  campaignId: string
  userIds: number[]
}

interface UpdateManualOrderMetadataResponse {
  budget: number
}

const manualMatchingOrderApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    updateManualOrderMetadata: builder.mutation<
      UpdateManualOrderMetadataResponse,
      UpdateManualOrderMetadataParams
    >({
      query: ({ campaignId, userIds }) => ({
        url: `${APP.TIKTOK_SERVER}/artist/spotify-campaigns/${campaignId}/manual-matching/order-metadata`,
        method: 'PUT',
        body: { userIds },
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useUpdateManualOrderMetadataMutation } = manualMatchingOrderApi
